
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Version } from '@/api/openapi';
import Pagination from '@/components/Pagination.vue';
import { parsePagination } from '@/utils';

@Component({
  components: { Pagination },
})
export default class ReviewQuestions extends Vue {
  @Action displayError!: (s: string) => void;
  @Action displaySuccess!: (s: string) => void;
  @Getter loggedInUserHasAnyPermission: any;

  data: Array<Version> | null = null;
  loading: boolean = true;
  pagination: any | null = null;

  async loadList(page?: number, limit?: number) {
    const variables = {
      page: page || undefined,
      limit: limit || undefined,
    };

    this.loading = true;
    this.data = [];

    try {
      const response = await this.$coreApi.versionList(variables);

      this.data = response.data;

      this.pagination = parsePagination(response);
    } catch (e) {
      this.$log.error(e);
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    } finally {
      this.loading = false;
    }
  }

  changeLimit(limit: number) {
    this.loadList(undefined, limit);
  }

  changePage(page: number) {
    this.loadList(page, this.pagination.currentLimit);
  }

  async created() {
    this.loadList();
  }
}
